// extracted by mini-css-extract-plugin
export default {"equivalence":"EmissionEquivalence_equivalence__TOwDY","icon":"EmissionEquivalence_icon__IURFH","text":"EmissionEquivalence_text__kex+M"};